module.exports = __webpack_public_path__ + "img/SHIELD.d540833d.svg";